import { jsxs as o, jsx as r } from "@emotion/react/jsx-runtime";
import { BusinessReachEnum as h } from "@partoohub/api-client";
import { Text as t, Stack as a, Sticker as f, Icon as C, FontAwesomeIconsPartooUsed as S, IconPrefix as B } from "@partoohub/ui";
import { BusinessCardContainer as I, FullWidthStack as g, CheckIconContainer as y } from "./BusinessCard.styled.js";
import { BusinessCardPhoto as E } from "./BusinessCardPhoto.js";
import { useBusinessModalContext as x } from "../../../../BusinessModalContext.js";
import { useCountData as k } from "../../../../hooks/useCountData.js";
import { useIsBusinessSelected as M } from "../../../../hooks/useIsBusinessSelected.js";
import { selectBusiness as _ } from "../../../../reducer/businessModal.actions.js";
import { BusinessStatusChip as v } from "./BusinessStatusChip.js";
import { BusinessModalErrorType as w } from "../../../../../../types/components/businessModal.types.js";
import { MAX_BUSINESSES_SELECTED as c } from "../../../../reducer/businessModal.reducer.js";
const H = ({
  business: e
}) => {
  const {
    dispatch: s,
    setError: i,
    translations: d
  } = x(), {
    selectedBusinessIdsCount: l,
    unselectedBusinessIdsCount: m
  } = k(), p = e.reach === h.GLOBAL, n = M({
    business: e
  });
  return /* @__PURE__ */ o(I, { direction: "row", alignItems: "center", gap: "8px", onClick: () => {
    const u = l >= c || m >= c;
    i(u ? {
      reason: w.MAX_LIMIT_REACHED
    } : {}), s(_({
      isSelected: n,
      businessId: e.id
    }));
  }, isSelected: n, children: [
    /* @__PURE__ */ r(E, { business: e }),
    /* @__PURE__ */ o(g, { gap: "0", children: [
      /* @__PURE__ */ r(t, { variant: "bodyMBold", children: e.name }),
      /* @__PURE__ */ o(a, { direction: "row", justifyContent: "space-between", alignItems: "center", children: [
        p ? /* @__PURE__ */ r(f, { dataTrackId: "brand_sticker", variant: "default", appearance: "outlined", children: /* @__PURE__ */ o(t, { variant: "bodySBold", children: [
          " ",
          d.reachGlobal,
          " "
        ] }) }) : /* @__PURE__ */ o(a, { gap: "0", children: [
          /* @__PURE__ */ r(t, { variant: "bodySRegular", color: "secondary", children: e.address_full }),
          /* @__PURE__ */ o(t, { variant: "bodySRegular", color: "secondary", children: [
            e.zipcode,
            " ",
            e.city
          ] })
        ] }),
        /* @__PURE__ */ r(v, { business: e })
      ] })
    ] }),
    n && /* @__PURE__ */ r(y, { gap: "0", alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ r(C, { icon: [S.faCheck, B.SOLID], iconSize: "12px", color: "white" }) })
  ] });
};
export {
  H as BusinessCard
};
